const safeLocalStorage = {
  getItem(key) {
    try { return localStorage.getItem(key); } catch { return null; }
  },
  setItem(key, value) {
    try { localStorage.setItem(key, value); } catch { /* storage blocked */ }
  },
  removeItem(key) {
    try { localStorage.removeItem(key); } catch { /* storage blocked */ }
  },
  get(key) {
    try { return localStorage[key]; } catch { return undefined; }
  },
  set(key, value) {
    try { localStorage[key] = value; } catch { /* storage blocked */ }
  },
};

export default safeLocalStorage;
